let instance = null;
class AppConfig {
    constructor(){
        if (!instance) {
            this.init();
            instance = this;
            this.server_url = '';
        }
        return instance;
    }

    init() {
        this.debug_mode = false;
        this.discount_debit_api = {
            https: true,
            basePath: window.apiUrl,
            path: 'search/api',
            collection: 'benefits',
            fields: ['city_id','benefit_title','is_network','category'],
        }
        this.api = {
            https: true,
            baseUrl: window.apiUrl,
            mediaUrl: window.mediaUrl,
            path: "api",
            platform: 'website',
            version: '2.0',
            requests: {
                generalDeclaration: 'generalDeclaration',
                contactUs: 'newContact',
                getContactUsPage: 'getContactUsPage',
                autocompleteRequest: 'generalAutoComplete',
                getHomepage: 'getNewHomePage',
                getOurStory: 'getOurStory',
                getContentPage: 'getContentPage',
                getDetailedBenefitByIdForWeb: 'getDetailedBenefitByIdForWeb',
                getDetailedTradeBenefit:'getDetailedTradeBenefit',
                sendAppLinkSms: 'sendAppLinkSms',
                searchBenefits: 'benefitsGeneralSearch',
                signupForNewsletter: 'signupForNewsletter',
                getMetaTagsRequest: 'getMetaTags',
                getSuppliersApplicationPage: 'getSuppliersApplicationPage',
                getUsersApplicationPage: 'getUsersApplicationPage',
                newUserApplication: 'newUserApplication',
                newSupplierApplication: 'newSupplierApplication',
                membershipValidation: 'CheckVipLink',
                getSmartWalletPageRequest: 'getSmartWalletPage',
                getMembershipGeneratorPage: 'getMembershipGeneratorPage',
                getClubMemberCertificate: 'getClubMemberCertificate',
                hotWebUserLogin: 'hotWebUserLogin',
                hotWebFirstLogin: 'hotWebFirstLogin',
                // generateWebVerificationCode: 'generateWebVerificationCode',
                getUserFavorites: 'getUserFavourites',
                addFavoriteBenefit: 'addFavouriteBenefit',
                removeFavoriteBenefit: 'removeFavouriteBenefit',
                // checkVerificationCode: 'checkWebVerificationCode',
                hotAddUser: 'hotAddUser',
                getUserData: 'getUserData',
                logout: 'logout',
                editUserInformation: 'editUserInformation',
                acquireCouponWeb: 'acquireCouponWeb',
                cleanUserSearchHistory: 'cleanUserSearchHistory',
                sendBenefitCoupon: 'sendBenefitCoupon',
                addToken: 'addToken',
                deleteToken: 'deleteToken',
                setDefaultToken: 'setDefaultToken',
                getAvailableCoupons: 'getAvailableCoupons',
                askTheExpert: 'askTheExpert',
                getExpertsPage: 'getExpertsPage',
                acquirePaidCoupon: 'acquirePaidCoupon',
                getStreetsByCityId: 'getStreetsByCityId',
                saveUserAddress: 'saveUserAddress',
                deleteUserAddress: 'deleteUserAddress',
                getDetailedBenefitCouponHash: 'getDetailedBenefitCouponHash',
                updateUserAddress: 'updateUserAddress',
                setDefaultAddress: 'setDefaultAddress',
                addItem: 'addItem',
                editItem: 'editItem',
                getCart: 'getCart',
                verifyCart: 'verifyCart',
                doPayment: 'doPayment',
                getUserOrders: 'getUserOrders',
                getDetailedUserOrder: 'getDetailedUserOrder',
                getItems: 'getItems',
                getCustomerSurvey: 'getCustomerSurvey',
                getIsMarketingApproved: 'getIsMarketingApproved',
                answerCustomerSurvey: 'answerCustomerSurvey',
                orderNotReceivedReply: 'orderNotReceivedReply',
                getApplicationLandingPage: 'getApplicationLandingPage',
                newIncompleteUserApplication: 'newIncompleteUserApplication',
                getUsersApplicationApprovalPage: 'getUsersApplicationApprovalPage',
                reactCrashLog: 'reactCrashLog',
                smartWalletApplication: "smartWalletApplication",
                getVehicleAdsPage: "getVehicleAdsPage",
                newVehicleLead: "newVehicleLead",
                sendLeadForm: "send_lead_form",
                getMagazineMainPageInfo: "getMagazineMainPageInfo",
                getArticleById: "getArticleById",
                getVideoArticleById: "getVideoArticleById",
                getMagazines: "getMagazines",
                getArticlesByCategory: "getArticlesByCategory",
                getVideoArticles: "getVideoArticles",
                getArticlesByAmount: "getArticlesByAmount",
                getLegalAdvicePage: 'getLegalAdvicePage',
                getLegalAdviceQuestion: 'getLegalAdviceQuestion',
                getLegalAdviceQuestions: 'getLegalAdviceQuestions',
                searchLegalAdviceQuestions: 'searchLegalAdviceQuestions',
                submitLegalAdviceQuestion: 'submitLegalAdviceQuestion',
                getAllBenefits: 'getAllBenefits',
                getCategoryBenefits: 'getCategoryBenefits',
                updateVideoArticlesViewCount: 'updateVideoArticlesViewCount',
                checkForPreviousUserApplication: 'checkForPreviousUserApplication',
                requestAccessToken: 'requestAccessToken',
                createInsuranceLead: 'createInsuranceLead',
                setTravelInsurancePopupAgreement: 'setTravelInsurancePopupAgreement',
                setLegalWaiverAgreement: 'setLegalWaiverAgreement',
                updateUserDataSharingConsent: 'updateUserDataSharingConsent',
                updateUserDataSharingAndMarketingConsent: 'updateUserDataSharingAndMarketingConsent',
                submitBenefitLeadForm: 'submitBenefitLeadForm',
                userLogin: 'userLogin',
                doLogin: 'doLogin',
                validateHotUser: 'validateHotUser',
                isMember: 'is-member',
                initLogin: 'init-login',
                login: 'login',
                register: 'register',
            },
        };

        this.full_path = '//' + window.baseUrl;
        this.media_path = '//' + window.mediaUrl;
    }
};

export default AppConfig;
